var ASC = 'ASC';
var DESC = 'DESC';
export var SORT = {
  ASC: ASC,
  DESC: DESC
};
export var OR_FILTER = 'orFilters';